import Vue from 'vue'
import VueAgile from 'vue-agile' /* eslint-disable-line */

Vue.use(VueAgile)
